var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoansSanctionedActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.01 24H10.01C9.74908 24.0016 9.49786 23.9011 9.31 23.72L5.59998 20.09H4.01001V18.09H6.01001C6.26748 18.091 6.51463 18.1913 6.70001 18.37L10.41 22H20.01C20.2752 22 20.5296 21.8946 20.7171 21.7071C20.9046 21.5196 21.01 21.2652 21.01 21C21.01 20.7348 20.9046 20.4804 20.7171 20.2929C20.5296 20.1054 20.2752 20 20.01 20H15.01V18H20.01C20.8057 18 21.5687 18.3161 22.1313 18.8787C22.694 19.4413 23.01 20.2044 23.01 21C23.01 21.7956 22.694 22.5587 22.1313 23.1213C21.5687 23.6839 20.8057 24 20.01 24Z",
    fill: "url(#paint0_linear_3151_4897)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.01 20.9999C12.6145 21.0008 12.2227 20.9236 11.8571 20.7726C11.4916 20.6215 11.1595 20.3997 10.88 20.1199L9.38 18.6199L10.8 17.2099L12.3 18.7099C12.3932 18.8024 12.5038 18.8758 12.6254 18.9256C12.7469 18.9755 12.8771 19.0009 13.0085 19.0004C13.1399 18.9999 13.27 18.9736 13.3912 18.9229C13.5124 18.8722 13.6224 18.7981 13.715 18.7049C13.8076 18.6116 13.8809 18.5011 13.9307 18.3795C13.9806 18.2579 14.006 18.1277 14.0056 17.9963C14.0051 17.8649 13.9788 17.7349 13.928 17.6137C13.8773 17.4925 13.8033 17.3825 13.71 17.2899L10.51 14.0899H4.01001V12.0899H10.92C11.0516 12.0891 11.1821 12.1143 11.3039 12.1641C11.4257 12.2138 11.5366 12.2872 11.63 12.3799L15.13 15.8799C15.549 16.2994 15.8343 16.8337 15.9498 17.4153C16.0654 17.9969 16.006 18.5997 15.7792 19.1476C15.5523 19.6954 15.1682 20.1637 14.6754 20.4934C14.1825 20.8231 13.603 20.9993 13.01 20.9999Z",
    fill: "url(#paint1_linear_3151_4897)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 22.0801H0V20.0801H1V13.0801H0V11.0801H3V22.0801Z",
    fill: "url(#paint2_linear_3151_4897)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3H15V6H17V3Z",
    fill: "url(#paint3_linear_3151_4897)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H18V4H20V0Z",
    fill: "url(#paint4_linear_3151_4897)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.01 15C17.2189 15 16.4455 14.7654 15.7877 14.3259C15.1299 13.8863 14.6172 13.2616 14.3145 12.5307C14.0117 11.7998 13.9325 10.9956 14.0869 10.2196C14.2412 9.4437 14.6222 8.73097 15.1816 8.17156C15.741 7.61215 16.4537 7.23121 17.2296 7.07687C18.0056 6.92253 18.8098 7.00172 19.5407 7.30447C20.2716 7.60722 20.8964 8.11991 21.3359 8.7777C21.7754 9.4355 22.01 10.2089 22.01 11C22.01 12.0609 21.5886 13.0783 20.8385 13.8284C20.0883 14.5786 19.0709 15 18.01 15ZM18.01 8.99999C17.6145 8.99999 17.2278 9.1173 16.8989 9.33706C16.57 9.55682 16.3136 9.86916 16.1623 10.2346C16.0109 10.6001 15.9713 11.0022 16.0484 11.3902C16.1256 11.7781 16.3161 12.1345 16.5958 12.4142C16.8755 12.6939 17.2319 12.8844 17.6198 12.9616C18.0078 13.0387 18.41 12.9991 18.7754 12.8477C19.1409 12.6964 19.4532 12.44 19.6729 12.1111C19.8927 11.7822 20.01 11.3956 20.01 11C20.01 10.4696 19.7993 9.96085 19.4242 9.58578C19.0491 9.21071 18.5405 8.99999 18.01 8.99999Z",
    fill: "url(#paint5_linear_3151_4897)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3151_4897",
    x1: 13.51,
    y1: 24.5556,
    x2: 13.51,
    y2: 17.2222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3151_4897",
    x1: 10.0087,
    y1: 21.8249,
    x2: 10.0087,
    y2: 10.9348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3151_4897",
    x1: 1.5,
    y1: 23.0986,
    x2: 1.5,
    y2: 9.65415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3151_4897",
    x1: 16,
    y1: 6.27778,
    x2: 16,
    y2: 2.61111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3151_4897",
    x1: 19,
    y1: 4.37037,
    x2: 19,
    y2: -0.518519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3151_4897",
    x1: 18.01,
    y1: 15.7407,
    x2: 18.01,
    y2: 5.96296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoansSanctionedActive);
export default __webpack_public_path__ + "static/media/loans-sanctioned-active.1dcac5236c1630445fab3e1173133acd.svg";
export { ForwardRef as ReactComponent };